import PaymentInformation from './PaymentInformation.component';

export default PaymentInformation;
